// Grilla key-value densa para paneles de indicadores.

import type { ReactNode } from 'react';

export interface KVItem {
  k: string;
  v: ReactNode;
  /** Si true, el valor se renderiza con text-ink (destacado). */
  strong?: boolean;
}

export function KVGrid({ items }: { items: KVItem[] }) {
  return (
    <dl className="grid grid-cols-[max-content_1fr] gap-x-3 gap-y-1 text-[11px]">
      {items.map(({ k, v, strong }) => (
        <div key={k} className="contents">
          <dt className="uppercase tracking-wider text-ink-subtle">{k}</dt>
          <dd className={`break-all tabular-nums ${strong ? 'text-ink' : 'text-ink-muted'}`}>
            {v ?? <span className="text-ink-subtle">—</span>}
          </dd>
        </div>
      ))}
    </dl>
  );
}
